module.exports = __webpack_public_path__ + "75f9a9460075936076d6d661760f7cd6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SL.svg
// module id = BkJg
// module chunks = 0